import IconIndexType from 'owa-service/lib/contract/IconIndexType';
import Item from 'owa-service/lib/contract/Item';
import TableViewConversationRelation from 'mini-mail-list-store/lib/store/schema/TableViewConversationRelation';
import { PropertyIcons } from 'mini-mail-list-item/lib/schema/PropertyIcons';
import getPropertyIconPerItemClass, {
    noteClassPropertyIconMap,
} from './getPropertyIconPerItemClass';

function isMeetingType(itemType: string) {
    return !!itemType && itemType.toLowerCase().indexOf('ipm.schedule.meeting') !== -1;
}

function getItemClassIcon(
    messageClasses: string[],
    messageIconIndex: IconIndexType,
    hasIrm: boolean
): PropertyIcons {
    let iconIndex: IconIndexType = messageIconIndex;
    if (hasIrm) {
        switch (iconIndex) {
            case 'MailReplied':
                iconIndex = 'MailIrmReplied';
                break;
            case 'MailForwarded':
                iconIndex = 'MailIrmForwarded';
                break;
            default:
                iconIndex = 'MailIrm';
                break;
        }
    }

    // Check to see if all message classes correspond to meeting requests
    let foundNonMeetingTypeClass = false;
    if (messageClasses) {
        const numberOfMessageClasses = messageClasses.length;
        if (numberOfMessageClasses === 1) {
            return getPropertyIconPerItemClass(messageClasses[0], iconIndex);
        } else {
            // Find a conversation icon to use.
            for (let i = 0; i < numberOfMessageClasses; i++) {
                if (!isMeetingType(messageClasses[i])) {
                    foundNonMeetingTypeClass = true;
                    break;
                }
            }
        }
    }

    return foundNonMeetingTypeClass
        ? noteClassPropertyIconMap[iconIndex ? iconIndex.toString() : null]
        : PropertyIcons.MailListViewAppointmentItem;
}

export default function getConversationIcon(
    tableConversationRelation: TableViewConversationRelation
): PropertyIcons {
    const { itemClasses, iconIndex, hasIrm } = tableConversationRelation;
    // add bug to wire the small icon end to end
    return getItemClassIcon(itemClasses, iconIndex, hasIrm);
}

export const getMessageIcon = (item: Item) =>
    getItemClassIcon([item.ItemClass], item.IconIndex, false /* hasIrm */);
